<template>
  <card class="stacked-form" :title="$t('users.createUser')" :on-cancel="cancel">
    <form @submit.prevent="registerUser">
      <div class="row">
        <div class="col-md-6">
          <material-input-field
            id="emailInput"
            ref="emailInput"
            v-model="email"
            :name="'email'"
            variant="static"
            :label="$t('users.email') + ' *'"
            :placeholder="$t('users.email')"
            @blur="checkEmailAvailability"
          />
          <small v-if="emailError" class="text-danger">{{ emailError }}</small>
        </div>
        <div class="col-md-6">
          <material-input-field
            id="employeeTitleInput"
            ref="employeeTitleInput"
            v-model="employeeTitle"
            :name="'employeeTitle'"
            variant="static"
            :label="$t('users.employeeTitle')"
            :placeholder="$t('users.employeeTitle')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="col-md-3 col-form-label">{{$t('users.role')}} *</label>
          <div class="col-md-9">
            <el-select ref="roleInput" v-model="role" :class="selectClass" :placeholder="$t('users.selectRole')">
              <el-option
                v-for="item in roleOptions"
                :key="item"
                :class="selectClass"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </div>
        <div v-if="enableUserGroups" class="col-md-6">
          <label class="col-md-3 col-form-label">{{$t('users.userGroup')}}</label>
          <div class="col-md-9">
            <el-select v-model="userGroupId" clearable :class="selectClass" :placeholder="$t('users.selectUserGroup')">
              <el-option
                v-for="group in userGroups"
                :key="group.id"
                :class="selectClass"
                :label="group.name"
                :value="group.id"
              />
            </el-select>
          </div>
        </div>
      </div>
      <div class="col-sm d-flex justify-content-end">
        <material-button class="mt-3" type="submit" variant="gradient" color="dark" :disabled="!!emailError">
          {{$t('common.submit')}}
        </material-button>
      </div>
    </form>
  </card>
</template>
<script>
import api from "../../services/api"
import { getApiErrorMessage } from "../../utils/apiError";
import { getCustomerConfig } from '../Settings/customerConfigHelper';
import { ElSelect, ElOption } from 'element-plus';
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';
import Card from "../../components/Card.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";

export default {
  components: {
    ElSelect,
    ElOption,
    Card,
    MaterialInputField,
    MaterialButton
  },
  emits: ['close', 'refresh-data'],
  data() {
    return {
      email: '',
      employeeTitle: '',
      role: '',
      emailError: '',
      roleOptions: ['Admin','User'],
      enableUserGroups: false,
      userGroups: [],
      userGroupId: ''
    };
  },
  computed: {
    selectClass() {
      let darkMode = localStorage.getItem('darkMode');
      if (darkMode === null) {
        darkMode = 'false';
      }
      if (darkMode === 'false') {
        return 'select-standard';
      } else {
        return 'select-primary';
      }
    }
  },
  async created() {
    this.enableUserGroups = await getCustomerConfig('EnableUserGroups') === true;
    if (this.enableUserGroups) {
      try {
        const res = await api.get('/UserGroup');
        this.userGroups = res.data || [];
      } catch (error) {
        console.error('Unable to load user groups:', error); // eslint-disable-line no-console
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    async checkEmailAvailability() {
      if (!this.email) {
        this.emailError = '';
        return;
      }
      try {
        const decodedToken = jwtDecode(Cookies.get('accessToken'));
        const response = await api.post('/identity/CheckEmail', {
          customerId: decodedToken.CustomerId,
          email: this.email,
        });
        if (response.data.value) {
          this.emailError = this.$t('errors.emailTaken');
        } else {
          this.emailError = '';
        }
      } catch (error) {
        this.emailError = this.$t('errors.emailCheckFailed');
        console.error('Email check error:', error); // eslint-disable-line no-console
      }
    },
    async registerUser() {
      if (this.validateInput()) {
        try {
          await api.post('/identity/RegisterUser', {
            email: this.email,
            employeeTitle: this.employeeTitle,
            roleName: this.role,
            userGroupId: this.userGroupId || null,
          });
          this.$toast.success(this.$t('users.created'), { timeout: 1500 });
          this.$emit('refresh-data');
          this.$emit('close');
        } catch (error) {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(getApiErrorMessage(this.$t, error), { timeout: 0 });
        }
      }
    },
    validateInput() {
      let success = true;
      if (this.email === '') {
        this.$toast.info(this.$t('errors.emailEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.role === '') {
        this.$toast.info(this.$t('errors.roleEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.emailError) {
        success = false;
      }
      return success;
    }
  }
};
</script>
<style></style>
